/**
 * Contact Form Status Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.contactFormStatusFormatter = function(value, row) {
    let html = '';
    switch (value) {
        case 'open':
            html += '<span class="badge badge-open">';
            html += __('Open');
            html += '</span>';
            break;
        case 'pending':
            html += '<span class="badge badge-pending">';
            html += __('Pending');
            html += '</span>';
            break;
        case 'closed':
            html += '<span class="badge badge-closed">';
            html += __('Closed');
            html += '</span>';
            break;
    }
    return html;
};
